export const SET_JOURNEY_NAV_STEP = 'SET_JOURNEY_NAV_STEP'
export const SET_SELECTED_JOURNEY = 'SET_JOURNEY_THEME'
export const SET_JOURNEY_STEP = 'SET_JOURNEY_STEP'

export const REQUEST_JOURNEYS = 'REQUEST_JOURNEYS'
export const RECEIVE_JOURNEYS = 'RECEIVE_JOURNEYS'
export const RECEIVE_JOURNEYS_FAILED = 'RECEIVE_JOURNEYS_FAILED'

export const RECEIVE_JOURNEY_STEPS = 'RECEIVE_JOURNEY_STEPS'

export const SET_PERSONALIZED_NAME = 'SET_PERSONALIZED_NAME'

export const REQUEST_JOURNEY_PDF = 'REQUEST_JOURNEY_PDF'
export const SET_JOURNEY_PDF_URL = 'SET_JOURNEY_PDF_URL'
export const JOURNEY_PDF_FAILED = 'JOURNEY_PDF_FAILED'

export const SET_KIOSK_MODE = 'SET_KIOSK_MODE'
export const JOURNEY_PRINT_FAILED = 'JOURNEY_PRINT_FAILED'
export const REQUEST_JOURNEY_PRINT = 'REQUEST_JOURNEY_PRINT'

export const SET_JOURNEY_SELECT_MODAL = 'SET_JOURNEY_SELECT_MODAL'



// WEBPACK FOOTER //
// ./src/constants/journey-constants.js